import React from "react";
import {
  GalleryCard,
  GalleryTitle,
  InnerGalleryCard,
  TypographyRegular,
} from "./HomeDetails.styled";

const HomeGalleryCard = ({ title, imgSrc, onClick }) => {
  return (
    <GalleryCard className="w-[45%] md:!w-[236px]" img={imgSrc} onClick={onClick}>
      <InnerGalleryCard>
        {/* <TypographyRegular color="#fff">Dokumentasi</TypographyRegular> */}
        <GalleryTitle>{title}</GalleryTitle>
      </InnerGalleryCard>
    </GalleryCard>
  );
};

export default HomeGalleryCard;
